module.exports = __webpack_public_path__ + "media/images/pages/bg_area_08-7a1cbd2d6591ca68bc60ac795e167bf9.png";